import { settingResource } from '@witkac/kartamiejska-resources';
import { Declination } from '@witkac/kartamiejska-shared';

import { LocalStorage } from '@/enums/storage.enum';

export default {
  namespaced: true,
  state: {
    // czy widoczny jest popup z instrukcją instalacji
    popup: false,
    // czy aplikacja jest w trybie online
    online: false,
    // wersja kompilacji
    packageVersion: process.env.PACKAGE_VERSION,
    // data kompilacji
    buildDate: process.env.PACKAGE_BUILD_DATE,
    appTitle: 'Obsługa użytkownika karty',
    // Nazwa karty
    cardName: {
      mianownik: 'Karta Mieszkańca',
      dopelniacz: 'Karty Mieszkańca',
      celownik: 'Karcie Mieszkańca',
      biernik: 'Kartę Mieszkańca',
      narzednik: 'Kartą Mieszkańca',
      miejscownik: 'Karcie Mieszkańca'
    }
  },
  mutations: {
    /**
     * Pokazywanie popupa
     *
     * @param {*} state
     */
    showPopup(state: any) {
      state.popup = true;
    },
    /**
     * Ukrywanie popupa
     *
     * @param {*} state
     */
    hidePopup(state: any) {
      state.popup = false;
      localStorage.setItem(LocalStorage.PWA_POPUP, 'true');
    },
    /**
     * Ustawia `online` na true
     *
     * @param {*} state
     */
    setOnline(state: any) {
      state.online = true;
    },
    /**
     * Ustawia `online` na false
     *
     * @param {*} state
     */
    setOffline(state: any) {
      state.online = false;
    },
    /**
     * Zapisuje dane konfiguracyjne karty
     *
     * @param {*} state
     * @param {Declination} data dane ustawienia
     */
    setCardName(state: any, data: Declination): void {
      state.cardName = data;
    }
  },
  actions: {
    /**
     * Pobiera ustawienie
     *
     * @param context context
     * @param id identyifkator encji
     */
    loadCardName: async (context: any, code: string): Promise<Declination> => {
      const response = await settingResource.settingFindPublic('CARD_NAME');
      const jsonData = JSON.parse(response.value);
      context.commit('setCardName', jsonData.data);
      return jsonData.data;
    }
  }
};
